import { GroupBase, StylesConfig } from 'react-select'

export type Option<T> = {
  value: T
  label: string
}

export type ReactSelectStyles<T> = Partial<
  StylesConfig<Option<T>, false, GroupBase<Option<T>>>
>

export function styles<T>(): ReactSelectStyles<T> {
  return {
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      background: isSelected ? '#ff9c00' : isFocused ? '#ff9c00' : undefined,
      color: isFocused || isSelected ? '#FFF' : '#000',
      ':hover': {
        ...provided[':hover'],
        background: '#ff9c00',
        color: '#FFF'
      }
    }),
    control: (base, { isFocused }) => ({
      ...base,
      boxShadow: '#ff9c00',
      borderColor: isFocused ? '#ff9c00' : undefined,
      ':hover': {
        borderColor: isFocused ? '#ff9c00' : undefined
      },
      borderRadius: 9999
    })
  }
}
